
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetReportRowDto } from '../models/work-budget-report-row-dto';
import { WorkBudgetReportMonthValueDto } from '../models/work-budget-report-month-value-dto';

export function getBudgetReportResponseDtoFormGroup() {
return new FormGroup({
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    rows: new FormControl<WorkBudgetReportRowDto[]>([]),
    totalRow: new FormControl<WorkBudgetReportMonthValueDto[]>([]),
    totalSoll: new FormControl<number | undefined>(undefined, [Validators.required]),
    totalIst: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      